import Store from '../Store';
import structure from '../../data/ressources/MarketProducts.json';

const MarketProductsStore = new Store('markets/products', structure);

export {MarketProductsStore};